import * as Yup from 'yup';

// Shared banner validation (used by Edit Banner)
// Keep minimal, non-breaking requirements for edit flow
export const BannerFormValidationSchema = Yup.object().shape({
  title: Yup.string()
    .required('Judul Banner harus diisi')
    .trim('Harus berupa karakter')
    .strict(true)
    .max(100, 'Maksimal 100 karakter'),
  url: Yup.string().optional().trim('Link tidak boleh kosong').strict(true),
  banner: Yup.mixed().optional(),
});
